import React, { useState, useEffect } from 'react';
import FormGroup from '../FormGroup';
import classNames from 'classnames/bind';
import styles from './Form.module.scss';
import { getData } from '~/helper/apiService';

const cx = classNames.bind(styles);

function ProjectForm({ keyForm, titleBtn = 'Submit', data = {}, handleSubmit = () => {}, fileInputRef }) {
  const [types, setTypes] = useState([]);
  const [selectedType, setSelectedType] = useState(String(data?.type_id || ''));

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const response = await getData('/projects/readType');
        if (response) {
          setTypes(response || []);
        }
      } catch (error) {
        console.error('Error fetching project types:', error);
      }
    };
    fetchTypes();
  }, []);

  // Cập nhật selectedType khi data.type_id thay đổi
  useEffect(() => {
    setSelectedType(String(data?.type_id || ''));
  }, [data?.type_id]);

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
  };

  return (
    <form className={cx('create-post')} key={keyForm} encType="multipart/form-data" onSubmit={handleSubmit}>
      <FormGroup title="Tên dự án" name="name" value={data?.name} placeholder="Title" />
      <div className={cx('form-group')}>
        <select
          className={cx('select')}
          name="type_id"
          value={selectedType}
          onChange={handleTypeChange}
          required
        >
          <option value="" disabled>Select a project type</option>
          {types.map((type) => (
            <option key={type.id} value={type.id}>{type.name}</option>
          ))}
        </select>
      </div>
      <FormGroup title="Thời gian" name="time" value={data?.time} placeholder="Title" />
      <FormGroup title="Ngôn ngữ" name="language" value={data?.language} placeholder="Title" />
      <FormGroup title="Mô tả" name="descriptions" value={data?.descriptions} type="textarea" />
      <FormGroup title="Github" name="github_link" value={data?.github_link} type="textarea" />
      <FormGroup title="Nội dung chi tiết" name="content" value={data?.content} type="textarea" />
      <FormGroup type="file" name="image" value={data?.image} accept="image/*" ref={fileInputRef} />
      <button type="submit">{titleBtn}</button>
    </form>
  );
}

export default ProjectForm;